import { LEVELS } from "../lib/format";

export function Dots({ level }: { level: number }) {
  return (
    <span className="dots" role="img" aria-label={`Level ${level} of 3: ${LEVELS[level - 1] ?? ""}`}>
      {[1, 2, 3].map((i) => (
        <i key={i} className={i <= level ? "on" : ""} />
      ))}
    </span>
  );
}
